export type UpsertPartnerQuoteInfoRequest = {
    lineOfBusiness: string;
    stateCode: string;
    emailId: string;
    firstName: string;
    lastName: string;
    zipCode: string;
    dateOfBirth: string;
    phoneNumber: string;
    referenceNumber: string;
    source: string;
    userType: string;
    agentId: string;
    agentName: string;
    premium: string;
    firstApplicationFormID: string;
    token: string;
    businessName: string;
    businessAddress: string;
    businessClassDescription: string;
    quoteUpdatedDate: string;
    quoteCreatedDate: string;
    agentNotes: string;
    disclosureNotes?: string;
    callReason: string;
    createdDate: string;
    correlationId?: string;
    quoteOutcome: string;
    primaryOutcomeType: string;
    secondaryOutcomeType: string;
    policyNumber: string;
    soldPremium: string;
    leadSource: string;
    language: string;
    effectiveDate: string;
    expirationDate: string;
    salesDate: string;
    paymentPlan: string;
    paymentConfirmationNumber: string;
    disclosuresRead: string[];
    disclosuresSelectedAsYes: string[];
    disclosuresSelectedAsNo: string[];
    disclosuresSelectedAsNA: string[];
    isEndorsement: boolean;
    hasElectronicLoggingDevice?: string;
    telematicsProgramType?: string;
    telematicsSelection?: string;
  };
  
  // // todo: change to save 
  export const InitialUpsertQuoteInputs = (): UpsertPartnerQuoteInfoRequest => {
    return {
        lineOfBusiness: "",
        stateCode: "",
        emailId: "",
        firstName: "",
        lastName: "",
        zipCode: "",
        dateOfBirth: "",
        phoneNumber: "",
        referenceNumber: "",
        source: "",
        userType: "",
        agentId: "",
        agentName: "",
        premium: "",
        firstApplicationFormID: "",
        token: "",
        businessName: "",
        businessAddress: "",
        businessClassDescription: "",
        quoteUpdatedDate: "",
        quoteCreatedDate: "",
        agentNotes: "",
        disclosureNotes: "",
        callReason: "",
        createdDate: "",
        correlationId: "",
        quoteOutcome: "",
        primaryOutcomeType: "",
        secondaryOutcomeType: "",
        policyNumber: "",
        soldPremium: "",
        leadSource: "",
        language: "English",
        effectiveDate: "",
        expirationDate: "",
        salesDate: "",
        paymentPlan: "",
        paymentConfirmationNumber: "",
        disclosuresRead: [],
        disclosuresSelectedAsYes: [],
        disclosuresSelectedAsNo: [],
        disclosuresSelectedAsNA: [],
        isEndorsement: false,
        hasElectronicLoggingDevice: "",
        telematicsProgramType: "",
        telematicsSelection: ""
       };
    };
    
export const UpsertInitialInputErrorMessages = (): UpsertPartnerQuoteInfoRequest => {
    return {
        lineOfBusiness: "",
        stateCode: "",
        emailId: "",
        firstName: "",
        lastName: "",
        zipCode: "",
        dateOfBirth: "",
        phoneNumber: "",
        referenceNumber: "",
        source: "",
        userType: "",
        agentId: "",
        agentName: "",
        premium: "",
        firstApplicationFormID: "",
        token: "",
        businessName: "",
        businessAddress: "",
        businessClassDescription: "",
        quoteUpdatedDate: "",
        quoteCreatedDate: "",
        agentNotes: "",
        disclosureNotes: "",
        callReason: "",
        createdDate: "",
        correlationId: "",
        quoteOutcome: "",
        primaryOutcomeType: "",
        secondaryOutcomeType: "",
        policyNumber: "",
        soldPremium: "",
        leadSource: "",
        language: "",
        effectiveDate: "",
        expirationDate: "",
        salesDate: "",
        paymentPlan: "",
        paymentConfirmationNumber: "",
        disclosuresRead: [],
        disclosuresSelectedAsYes: [],
        disclosuresSelectedAsNo: [],
        disclosuresSelectedAsNA: [],
        isEndorsement: false,
        hasElectronicLoggingDevice: "",
        telematicsProgramType: "",
        telematicsSelection: ""
    };
  }